<pbc-filter-preset
  [filter]="vorlagen.preset$ | async"
  [filters]="vorlagen.presets$ | async"
  [name]="vorlagen.search$ | async"
  (select)="vorlagen.setFilter($event)"
  (save)="vorlagen.writeFilter($event)"
  (delete)="vorlagen.deleteFilter($event)"
></pbc-filter-preset>
